import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { BarChart2, LogIn, LogOut, AlertTriangle, RefreshCw } from 'lucide-react';

export default function Header() {
  const { user, logout, jiraTokenWarning, jiraTokenExpired, jiraTokenMinutesLeft } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (p) => location.pathname === p ? 'nav-link active' : 'nav-link';

  return (
    <>
      <header className="header">
        <div className="header-inner">
          <Link to="/" className="header-logo">🔄 Retro<span>App</span></Link>
          <nav className="header-nav">
            <Link to="/" className={isActive('/')}>Sessions</Link>
            {user && <Link to="/reports" className={isActive('/reports')}><span className="flex items-center gap-2"><BarChart2 size={14} /> Reports</span></Link>}
            <div style={{ width: 1, height: 24, background: 'var(--border)', margin: '0 8px' }} />
            {user ? (
              <div className="flex items-center gap-3">
                {user.avatarUrl && <img src={user.avatarUrl} alt={user.displayName} style={{ width: 28, height: 28, borderRadius: '50%', border: '2px solid var(--accent)' }} />}
                <span className="text-sm text-muted">{user.displayName}</span>
                <button className="btn btn-ghost btn-sm" onClick={logout}><LogOut size={14} /> Sign out</button>
              </div>
            ) : (
              <button className="btn btn-primary btn-sm" onClick={() => navigate("/")}><LogIn size={14} /> Sign In</button>
            )}
          </nav>
        </div>
      </header>

      {jiraTokenExpired && (
        <div style={{ background: 'var(--red-dim)', borderBottom: '1px solid var(--red)', padding: '10px 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
          <AlertTriangle size={14} style={{ color: 'var(--red)', flexShrink: 0 }} />
          <span className="text-sm" style={{ color: 'var(--red)' }}><strong>Your Jira session has expired.</strong> Jira actions will fail until you sign back in.</span>
          <button className="btn btn-danger btn-sm" onClick={logout} style={{ flexShrink: 0 }}><RefreshCw size={12} /> Sign in again</button>
        </div>
      )}
      {jiraTokenWarning && !jiraTokenExpired && (
        <div style={{ background: 'var(--yellow-dim)', borderBottom: '1px solid var(--yellow)', padding: '8px 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
          <AlertTriangle size={14} style={{ color: 'var(--yellow)', flexShrink: 0 }} />
          <span className="text-sm" style={{ color: 'var(--yellow)' }}><strong>Jira session expires in {jiraTokenMinutesLeft} min.</strong> Finish current phase then re-authenticate.</span>
          <button className="btn btn-sm" style={{ background: 'var(--yellow-dim)', color: 'var(--yellow)', border: '1px solid var(--yellow)', flexShrink: 0 }} onClick={logout}><RefreshCw size={12} /> Re-auth now</button>
        </div>
      )}
    </>
  );
}
